

const SvgLogo = () => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="30" cy="30" r="15" fill="#FF6347" /> {/* Tomato */}
        <circle cx="50" cy="30" r="15" fill="#1E90FF" /> {/* Dodger Blue */}
        <circle cx="70" cy="30" r="15" fill="#32CD32" /> {/* Lime Green */}
        <circle cx="40" cy="50" r="15" fill="#FFD700" /> {/* Gold */}
        <circle cx="60" cy="50" r="15" fill="#FF69B4" /> {/* Hot Pink */}
        <circle cx="50" cy="70" r="15" fill="#4B0082" /> {/* Indigo */}
    </svg>
);



const actionBarConfig = {
    appTitle: "Racklet (Beta)",
    appLogo: <SvgLogo />, // SVG logo as a React component
    position: "bottom",
    variant: "responsive",
    leftActions: [
        {
            id: "menu",
            type: "menu",
            icon: "Menu",
            tooltip: "Open Menu",
        },
    ],
    rightActions: [

        {
            id: "show_tiles",
            type: "icon",
            icon: "Grid",
            tooltip: "Racklet Tiles",
        },
        {
            id: "profile_info",
            type: "icon",
            icon: "Person",
            tooltip: "Profile Info",
        },
        {
            id: "toggle_theme",
            type: "icon",
            icon: "DarkMode",
            tooltip: "Toggle Theme",
        },
    ],
};

export default actionBarConfig;